import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import $ from "jquery";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";

export default function COMPONENT(props) {
  const {
    field: { displayField, apiGet, betChar, ...field },
    changeTrigger,
    related,
    table,
    defaultValue,
    selectOption,
  } = props;
  const selectRef = useRef(null);
  const _token = localStorage.getItem("_token");
  const [current, setCurrent] = useState(defaultValue ? defaultValue : "");
  const [fields, setFields] = useState([]);
  const [height, setHeight] = useState(0);
  const [foreignData, setForeignData] = useState([]);
  const [showKey, setShowKey] = useState("");
  const { proxy, unique_string, lang } = useSelector((state) => state);
  const [relatedTable, setRelatedTable] = useState({});
  const [pk, setPK] = useState(undefined);
  const [apiDatas, setApiDatas] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [selectedValue, setSelectedValue] = useState(null);

  const { foreign_keys } = table;

  const corespondingKey = foreign_keys.find((key) => key.field_id == field.id);
  useEffect(() => {
    if (apiGet && pk) {
      const { api_detail } = apiGet;
      fetch(`${proxy()}${api_detail?.url}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, data } = res;
          if (success && data && data.length > 0) {
            const newData = data.map((item) => {
              if (displayField && displayField?.length > 0) {
                let label = displayField
                  .map(({ value }) => item[value])
                  .join(betChar ? betChar : "|");
                return {
                  value: item,
                  label: label,
                };
              }
              return {
                value: item,
                label: item[pk],
              };
            });
            setApiDatas(newData);
          }
        });
    }
  }, [apiGet, pk, displayField]);
  useEffect(() => {
    const key = isFieldForeign();
    const { foreign_keys } = table;
    const corespondingKey = foreign_keys.find(
      (key) => key.field_id == field.id
    );
    if (defaultValue !== undefined) {
      if (key) {
        // fetch(`${proxy()}/apis/apis/table/data/${table_alias}`).then(res => res.json()).then(res => {/table/:table_id/data
        const dataBody = {
          table_id: corespondingKey.table_id,
          start_index: startIndex,
          criteria: {},
          exact: true,
        };

        // console.log(dataBody)
        fetch(`${proxy()}/api/foreign/data`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify(dataBody),
        })
          .then((res) => res.json())
          .then((res) => {
            const { success, data, fields, sumerize, statistic } = res;
            // console.log(res)

            setForeignData(data);
            setFields(fields);

            const { ref_field_id } = key;
            const primaryField = fields?.find(
              (field) => field.id == ref_field_id
            );
            if (primaryField) {
              setPK(primaryField.fomular_alias);
            }
          });
      } else {
        setCurrent(defaultValue);
      }
    } else {
      if (!isFieldForeign() && field.AUTO_INCREMENT) {
        fetch(`${proxy()}/apis/field/autoid/${field.id}`)
          .then((res) => res.json())
          .then((res) => {
            const { data } = res;
            // console.log(data.id)
            console.log("/apis/field/autoid/", data);
            setCurrent(data?.id);
            changeTrigger(field, data?.id);
          });
      } else {
        const key = isFieldForeign();
        if (key) {
          if (foreignData.length == 0) {
            const dataBody = {
              table_id: corespondingKey.table_id,
              start_index: startIndex,
              criteria: {},
            };

            // console.log(69, dataBody)
            fetch(`${proxy()}/api/foreign/data`, {
              method: "POST",
              headers: {
                Authorization: _token,
                "content-type": "application/json",
              },
              body: JSON.stringify(dataBody),
            })
              .then((res) => res.json())
              .then((res) => {
                const { success, data, fields, sumerize, statistic } = res;
                // console.log(82, res)
                setForeignData([
                  ...(data?.filter((record) => record !== undefined) || []),
                ]);
                setFields(fields);
                const { ref_field_id } = key;
                // console.log(key)
                const primaryField = fields?.find(
                  (field) => field.id == ref_field_id
                );
                if (primaryField) {
                  // console.log(primaryField)
                  setPK(primaryField.fomular_alias);
                }
              });
          }
        }
      }
    }
  }, [defaultValue]);

  useEffect(() => {}, [pk]);

  const [loadedRecordCount, setLoadedRecordCount] = useState(0);
  const [options, setOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const loadOptions = async (search, loadedOptions, { page }) => {
    console.log("pagepagepage", page);

    let dataBody = {
      table_id: corespondingKey.table_id,
      start_index: page,
      type: "or",
    };

    if (search && search.trim() !== "") {
      const criteria = {};
      const criteria_type = {};

      if (!displayField?.length) {
        criteria[pk] = search;
      }
      for (const k in displayField) {
        criteria[displayField[k].value] = search;
        criteria_type[displayField[k].value] = displayField[k]?.type.value;
      }

      dataBody.criteria = criteria;
      dataBody["criteria_type"] = criteria_type;
    }

    const response = await fetch(`${proxy()}/api/foreign/data`, {
      method: "POST",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
      body: JSON.stringify(dataBody),
    });
    const res = await response.json();
    // console.log(res);

    const returnedData = res.data;

    const dataWithoutNull =
      returnedData?.filter(
        (record) => record !== null && record !== undefined
      ) || [];

    setForeignData(dataWithoutNull);
    setLoadedRecordCount((prevCount) => prevCount + dataWithoutNull.length);

    let hasMoreValue = true;

    if (!returnedData?.length) {
      hasMoreValue = false;
    }

    const options = dataWithoutNull.map((d) => {
      if (displayField?.length) {
        let label = displayField
          .map(({ value }) => d[value])
          .join(betChar ? betChar : "|");
        return {
          value: d,
          label: label,
        };
      }
      return {
        value: d,
        label: d[pk],
      };
    });
    // d?.[displayField] ? d[displayField] :

    setOption(options);
    if (defaultValue) {
      const foundOption = options.find(
        (option) => option.value === JSON.stringify(defaultValue)
      );
      if (foundOption) {
        setSelectedOption(foundOption);
      }
    }
    return {
      options: options,
      hasMore: hasMoreValue,
      additional: {
        page: hasMoreValue ? page + 15 : page,
      },
    };
  };

  const isFieldForeign = () => {
    if (table) {
      const { foreign_keys } = table;
      const key = foreign_keys.find((key) => key.field_id == field.id);
      if (key) {
        return key;
      }
    }
    return false;
  };

  const isPrimaryKey = () => {
    if (table) {
      const { primary_key } = table;
      const key = primary_key.find((key) => key == field.id);
      if (key) {
        return key;
      }
    }
    return false;
  };

  const fieldChangeData = (e) => {
    // console.log(e.target.value)
    if (Array.isArray(e)) {
      // setCurrent(value[pk]);
      changeTrigger(
        field,
        e.map(({ value }) => value[pk])
      );
    } else {
      const rawJSON = e.target.value;
      const value = rawJSON;
      setCurrent(value[pk]);
      changeTrigger(field, value[pk]);
    }
  };

  const changeRawData = (e) => {
    const { value } = e.target;
    setCurrent(value);
    changeTrigger(field, value);
  };

  const focusTrigger = () => {
    setHeight(250);
  };

  const generateData = (data) => {
    // console.log(data)
    // console.log(pk)
    if (pk && data) {
      return data[pk];
    }
    return null;
  };

  // const dataClickedTrigger = (data) => {
  //     setCurrent(data);
  //     changeTrigger(field, data[pk])
  // }changeRawData

  const handleChange = (option) => {
    if (Array.isArray(option)) {
      setSelectedValue(option);
      fieldChangeData(option);
    } else {
      setSelectedValue(option);
      fieldChangeData({ target: { value: option.value } });
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleScrollToBottom = () => {
    if (!isLoading) {
      setIsLoading(true);
      // console.log("Reached bottom!");
      setStartIndex((prevIndex) => prevIndex + 1);
    }
  };

  // console.log(JSON.stringify(defaultValue))
  const [defaultOption, setDefaultOption] = useState(null);

  const [initialValue, setInitialValue] = useState(null);
  // console.log(defaultOption)
  useEffect(() => {
    const fetchDataForDefaultValue = async () => {
      const { foreign_keys } = table;
      const corespondingKey = foreign_keys.find(
        (key) => key.field_id == field.id
      );
      if (corespondingKey) {
        const dataBody = {
          table_id: corespondingKey.table_id,
          start_index: 0,
          require_count: false,
          //  exact: true
        };

        const criteria = {};

        criteria[pk] = defaultValue;
        dataBody.criteria = criteria;
        // console.log(290, dataBody)
        const response = await fetch(`${proxy()}/api/foreign/data`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify(dataBody),
        });

        const res = await response.json();

        let returnedData = res?.data;

        const foundData = returnedData?.find(
          (d) => d != undefined && d[pk] === defaultValue
        );
        // console.log(criteria)
        const label = generateData(foundData);
        // console.log(label);

        if (foundData) {
          const dataOption = {
            value: JSON.stringify(foundData),
            label: generateData(foundData),
          };

          if (displayField?.length) {
            let label = displayField
              .map(({ value }) => foundData[value])
              .join(betChar ? betChar : "|");

            dataOption.label = label;
          }

          setDefaultOption(dataOption);
          if (defaultValue) {
            setSelectedValue(dataOption);
          }
        }
      }
    };
    if (current != undefined) {
      fetchDataForDefaultValue();
    }
  }, [defaultValue, pk]);
  // console.log(pk)

  if (isPrimaryKey()) {
    if (!isFieldForeign()) {
      return (
        <div class="row justify-content-center">
          <div class="col-md-8">
            <form>
              <div class="form-group">
                <label for="name">
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                <input
                  type={field.AUTO_INCREMENT ? "text" : "number"}
                  className="form-control"
                  placeholder=""
                  onChange={changeRawData}
                  value={defaultValue == undefined ? current : defaultValue}
                  // defaultValue={
                  //   defaultValue == undefined ? current : defaultValue
                  // }
                  readOnly={field.AUTO_INCREMENT ? true : false}
                />
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      if (selectOption) {
        return (
          <div class="row justify-content-center">
            <div class="col-md-8">
              <form>
                <div class="form-group">
                  <label for="name">
                    {field?.title?.content || field.field_name}
                    {!field.NULL && <span style={{ color: "red" }}> *</span>}
                  </label>

                  <AsyncPaginate
                    placeholder={lang["select value"]}
                    loadOptions={loadOptions}
                    onChange={handleChange}
                    isSearchable={true}
                    value={selectedValue}
                    styles={{
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "300px",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    additional={{
                      page: 0,
                    }}
                    allowCreateWhileLoading={false} // Không cho phép tạo mới khi đang tải dữ liệu
                  />
                </div>
              </form>
            </div>
          </div>
        );
      } else {
        return (
          <div class="row justify-content-center">
            <div class="col-md-8">
              <form>
                <div class="form-group">
                  <label for="name">
                    {field?.title?.content || field.field_name}
                    {!field.NULL && <span style={{ color: "red" }}> *</span>}
                  </label>
                  <input
                    type={field.AUTO_INCREMENT ? "text" : "number"}
                    className="form-control"
                    placeholder=""
                    onChange={changeRawData}
                    defaultValue={
                      defaultValue == undefined ? current : defaultValue
                    }
                    readOnly={field.AUTO_INCREMENT ? true : false}
                  />
                </div>
              </form>
            </div>
          </div>
        );
      }
    }
  } else {
    if (!isFieldForeign()) {
      return (
        <div class="row justify-content-center">
          <div class="col-md-8">
            <form>
              <div class="form-group">
                <label for="name">
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                <input
                  type={field.AUTO_INCREMENT ? "text" : "number"}
                  className="form-control"
                  placeholder=""
                  onChange={changeRawData}
                  value={current}
                  // readOnly={field.AUTO_INCREMENT ? true : false}
                />
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      return apiGet ? (
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form>
              <div className="form-group">
                <label>
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                <div className="d-flex align-items-center">
                  <Select
                    isMulti
                    options={
                      apiDatas &&
                      apiDatas.length > 0 &&
                      apiDatas.map(({ value, label }) => ({
                        value,
                        label,
                      }))
                    }
                    value={selectedValue}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                    }}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="btn btn-success mt-0 ml-3"
                    onClick={() => handleChange(apiDatas.slice(0, 1))}
                  >
                    Thêm
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form>
              <div className="form-group">
                <label>
                  {field?.title?.content || field.field_name}
                  {!field.NULL && <span style={{ color: "red" }}> *</span>}
                </label>
                <AsyncPaginate
                  placeholder={lang["select value"]}
                  loadOptions={loadOptions}
                  onChange={handleChange}
                  isSearchable={true}
                  value={selectedValue}
                  styles={{
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "300px",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  additional={{
                    page: 0,
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
}
